import React from "react";
import { withStyles } from "@material-ui/styles";
import { get, filter, includes, map, sortBy } from "lodash";

import TableRow from "@material-ui/core/TableRow";

import TableCellStyled from "../Common/TableCellStyled";

import { formatDate } from "../../utils/date";
import { displayData } from "../../utils/data";
import { getAttributeValue } from "../../utils/profile";

import colors from "../../assets/style/colors";
import EllipsedTextNew from "../Common/EllipsedTextNew";

const styles = {
  tableRowHover: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: `${colors.lightGreenBg} !important`,
    },
  },
};

const ProfileLogRow = (props) => {
  const {
    classes,
    item,
    index,
    language,
    lov,
    openDetails,
    profileTypesCounts,
  } = props;

  const humanEvent = get(
    filter(
      get(item, ["events"]),
      (e) =>
        includes([58, 59, 60, 61], get(e, ["type", "id"])) &&
        get(e, ["active"]) &&
        get(e, ["profile", "type", "id"]) === 1
    ),
    [0]
  );
  const truckEvent = get(
    filter(
      get(item, ["events"]),
      (e) =>
        includes([58, 59, 60, 61], get(e, ["type", "id"])) &&
        get(e, ["active"]) &&
        get(e, ["profile", "type", "id"]) === 2
    ),
    [0]
  );
  const trailerEvents = sortBy(
    filter(
      get(item, ["events"]),
      (e) =>
        includes([58, 59, 60, 61], get(e, ["type", "id"])) &&
        get(e, ["active"]) &&
        get(e, ["profile", "type", "id"]) === 3
    ),
    (e) => getAttributeValue(e, 121)
  );
  const containerEvents = sortBy(
    filter(
      get(item, ["events"]),
      (e) =>
        includes([58, 59, 60, 61], get(e, ["type", "id"])) &&
        get(e, ["active"]) &&
        get(e, ["profile", "type", "id"]) === 4
    ),
    (e) => getAttributeValue(e, 121)
  );
  const mainEvent = truckEvent || humanEvent;

  return (
    <TableRow
      style={{
        backgroundColor: index % 2 === 1 ? colors.tableDarkBg : colors.white,
      }}
      hover={true}
      classes={{ hover: classes.tableRowHover }}
      onClick={openDetails}
    >
      <TableCellStyled className="text-54">
        {displayData(get(item, ["id"]))}
      </TableCellStyled>
      <TableCellStyled className="text-54">
        {formatDate(
          getAttributeValue(mainEvent, 76) || getAttributeValue(mainEvent, 77)
        )}
      </TableCellStyled>
      <TableCellStyled className="text-54">
        {displayData(get(mainEvent, ["zone", "site", "name"]))}
      </TableCellStyled>
      <TableCellStyled className="text-54">
        {displayData(get(mainEvent, ["zone", "name"]))}
      </TableCellStyled>
      <TableCellStyled className="text-54">
        {displayData(get(item, ["type", `name_${language}`]))}
      </TableCellStyled>
      <TableCellStyled className="text-54">
        {displayData(getAttributeValue(mainEvent, 105, lov, language))}
      </TableCellStyled>
      <TableCellStyled className="text-54">
        {displayData(get(humanEvent, ["profile", "name"]))}
      </TableCellStyled>
      <TableCellStyled className="text-54">
        {displayData(get(truckEvent, ["profile", "name"]))}
      </TableCellStyled>
      {map(new Array(profileTypesCounts[3]).fill(""), (i, index) =>
        get(trailerEvents, [index]) ? (
          <TableCellStyled
            className="text-54"
            key={get(trailerEvents, [index, "id"])}
          >
            {displayData(get(trailerEvents, [index, "profile", "name"]))}
          </TableCellStyled>
        ) : (
          <TableCellStyled key={index * 13} className="text-54">
            -
          </TableCellStyled>
        )
      )}
      {map(new Array(profileTypesCounts[4]).fill(""), (i, index) =>
        get(containerEvents, [index]) ? (
          <TableCellStyled
            className="text-54"
            key={get(containerEvents, [index, "id"])}
          >
            {displayData(get(containerEvents, [index, "profile", "name"]))}
          </TableCellStyled>
        ) : (
          <TableCellStyled key={index * 17} className="text-54">
            -
          </TableCellStyled>
        )
      )}
      <TableCellStyled className="text-54">
        {formatDate(get(item, ["created_on"]))}
      </TableCellStyled>
      <TableCellStyled className="text-54">
        {displayData(get(item, ["created_by"]))}
      </TableCellStyled>
      <TableCellStyled className="text-54">
        {getAttributeValue(mainEvent, 19) ? (
          <EllipsedTextNew
            text={getAttributeValue(mainEvent, 19)}
            maxHeight={34}
          />
        ) : (
          "-"
        )}
      </TableCellStyled>
    </TableRow>
  );
};

export default withStyles(styles)(ProfileLogRow);
